import * as React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Button from "@mui/material/Button";

export type ConfirmDeleteSingleImageLabels = {
    title: string;
    text: string;
    acceptButton: string;
    cancelButton: string;
};

type ConfirmDeleteSingleImageProps = {
    labels: ConfirmDeleteSingleImageLabels;
    show: boolean;
    onClose: () => void;
    onAccept: () => void;
};

export function ConfirmDeleteSingleImage({
    show,
    onClose,
    labels,
    onAccept
}: ConfirmDeleteSingleImageProps) {
    return (
        <Dialog open={show} onClose={onClose}>
            <DialogTitle>{labels.title}</DialogTitle>
            <DialogContent sx={{ maxWidth: '390px' }}>{labels.text}</DialogContent>
            <DialogActions>
                <Button onClick={onClose}>{labels.cancelButton}</Button>
                <Button onClick={onAccept}>{labels.acceptButton}</Button>
            </DialogActions>
        </Dialog>
    );
}
